<template>
  <div>
    <b-card title="Informasi Akun" class="mb-3">
      <b-row>
        <b-col md="6">
          <b-form-group label="Nama">
            <b-form-input :value="account.name || '-'" disabled />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Nama Pengguna">
            <b-form-input :value="account.username || '-'" disabled />
          </b-form-group>
        </b-col>
      </b-row>
      <small class="text-muted">Nama dan nama pengguna dikelola melalui administrasi user.</small>
    </b-card>

    <b-card v-if="isSchoolAdmin" title="Data Sekolah" class="mb-3">
      <ValidationObserver ref="schoolForm">
        <form @submit.prevent="submitSchool">
          <b-row>
            <b-col md="6" v-for="(field, key) in schoolModel" :key="key">
              <form-group-input
                :ref="key"
                :type="field.type"
                :label="field.label"
                :options="getOptions(field)"
                :need-label="true"
                v-model="field.value"
                :rules="field.rules"
                :id="key"
              />
            </b-col>
          </b-row>
          <b-button type="submit" variant="primary" :disabled="schoolLoading">
            <font-awesome-icon icon="spinner" spin v-if="schoolLoading" />
            Simpan Data Sekolah
          </b-button>
        </form>
      </ValidationObserver>
    </b-card>

    <b-card title="Ubah Password">
      <ValidationObserver ref="passwordForm">
        <form @submit.prevent="submitPassword">
          <b-row>
            <b-col md="4" v-for="(field, key) in passwordModel" :key="key">
              <form-group-input
                :ref="key"
                :type="field.type"
                :label="field.label"
                :need-label="true"
                v-model="field.value"
                :rules="field.rules"
                :id="key"
              />
            </b-col>
          </b-row>
          <b-button type="submit" variant="primary" :disabled="passwordLoading">
            <font-awesome-icon icon="spinner" spin v-if="passwordLoading" />
            Ubah Password
          </b-button>
          <b-button :to="'/'" variant="secondary" class="ml-3">Batal</b-button>
        </form>
      </ValidationObserver>
    </b-card>
  </div>
</template>

<script>
import { saveProcess, setModelValue, scrollToError, objectToOptions } from "@/_helpers";
import FormGroupInput from "@/components/FormGroupInput.vue";
import User from "@/models/User.js";
import School from "@/models/School.js";

const userModel = new User();
const schoolModel = new School();

export default {
  components: {
    FormGroupInput,
  },
  data() {
    return {
      account: {},
      schoolModel: this.createSchoolModel(),
      passwordModel: {
        old_password: {
          type: "password",
          label: "Password Lama",
          rules: "required",
        },
        password: {
          type: "password",
          label: "Password Baru",
          rules: "required|min:6",
        },
        password_confirmation: {
          type: "password",
          label: "Konfirmasi Password Baru",
          rules: "required|confirmed:password",
        },
      },
      schoolLoading: false,
      passwordLoading: false,
    };
  },
  computed: {
    isSchoolAdmin() {
      return this.account.role === "admin-sekolah";
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    createSchoolModel() {
      const model = schoolModel.init();
      return {
        kepsek: model.kepsek,
        bendahara: model.bendahara,
        total_student: model.total_student,
        phone_number: model.phone_number,
      };
    },
    getOptions(field) {
      return typeof field.options !== "undefined" ? objectToOptions(field.options) : null;
    },
    getDetail() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "me")
        .then((response) => {
          this.account = response.data;
          if (this.isSchoolAdmin && response.data.school) {
            setModelValue(this.schoolModel, {
              ...response.data.school,
              phone_number: response.data.phone_number,
            });
          }
        })
        .catch((error) => {
          this.$store.dispatch("notification/error", error);
        });
    },
    submitSchool() {
      this.$refs.schoolForm.validate().then((valid) => {
        if (!valid || this.schoolLoading) {
          scrollToError(this.$refs.schoolForm);
          return;
        }

        saveProcess(this.schoolModel, true)
          .then((payload) => {
            this.schoolLoading = true;
            return userModel.updateSchool(payload);
          })
          .then(() => {
            this.schoolLoading = false;
            this.$store.dispatch("account/setAccountData");
            this.$store.dispatch("notification/success", "Data sekolah berhasil diubah.");
          })
          .catch((error) => {
            this.schoolLoading = false;
            if (error.message !== "dismiss") {
              this.$store.dispatch("notification/error", error);
            }
          });
      });
    },
    submitPassword() {
      this.$refs.passwordForm.validate().then((valid) => {
        if (!valid || this.passwordLoading) {
          scrollToError(this.$refs.passwordForm);
          return;
        }

        saveProcess(this.passwordModel, true)
          .then((payload) => {
            this.passwordLoading = true;
            return userModel.changePassword(payload);
          })
          .then(() => {
            this.passwordLoading = false;
            Object.keys(this.passwordModel).forEach((key) => {
              this.passwordModel[key].value = null;
            });
            this.$refs.passwordForm.reset();
            this.$store.dispatch("notification/success", "Password berhasil diubah.");
          })
          .catch((error) => {
            this.passwordLoading = false;
            if (error.message !== "dismiss") {
              this.$store.dispatch("notification/error", error);
            }
          });
      });
    },
  },
};
</script>
